import React, { useState, useEffect } from 'react';
import './AuthForm.css';
import { useAuth } from '../../contexts/AuthProvider/AuthProvider';
import { AthenaCore } from 'athena-core';
import Button from '../Button';
import Unit from '../Modular/Unit';
import MicroUnit from '../Modular/MicroUnit';
import { useWindowSize } from '../../hooks/useWindowSize';
import Assembly from '../Modular/Assembly';

import { Link } from 'react-router-dom';

interface AuthFormProps {
  mode: 'login' | 'signup';
  toggleAuthState: () => void;
  toggleShowForm: () => void;
}

const AuthForm: React.FC<AuthFormProps> = ({
  mode,
  toggleAuthState,
  toggleShowForm,
}) => {
  const { login, signup, logout, loading, user } = useAuth();
  const windowSize = useWindowSize();
  const responsiveButtonWidth = windowSize.width <= 798 ? '5' : '7';
  const responsiveSize = windowSize.width <= 798 ? '5' : '7';

  const responsiveArrangement = windowSize.width <= 798 ? 'column' : 'row';

  console.log(user);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isStrongPassword, setIsStrongPassword] = useState<boolean>(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  useEffect(() => {
    const passwordIsStrong = (): boolean => {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{12,}$/;
      return regex.test(password);
    };
    setIsStrongPassword(passwordIsStrong());
  }, [password]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (mode === 'login') {
      await login({ email, password });
    } else {
      if (isStrongPassword) {
        await signup({ email, password, firstName, lastName });
      } else {
        AthenaCore.openModal({
          title: 'Error',
          message: 'please use strong password',
          type: 'error',
        });
      }
    }
  };

  const showWeakPasswordPrompt =
    !isStrongPassword && password.length <= 11 && password.length > 7
      ? true
      : false;

  return (
    <Assembly
      as="form"
      onSubmit={handleSubmit}
      className="auth-form"
      position="relative"
    >
      <MicroUnit as="h2" h2Color="text-light">
        {mode === 'login' ? 'Login' : 'Sign Up'}
      </MicroUnit>

      <Button
        variant="outlinelight"
        position="absolute"
        positionRight="1"
        positionTop="2"
        onClick={toggleShowForm}
      >
        X
      </Button>

      {mode === 'signup' && (
        <>
          <div className="form-group">
            <MicroUnit
              as="label"
              labelTypography="label"
              labelColor="text-primary"
            >
              First Name:
            </MicroUnit>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <MicroUnit
              as="label"
              labelTypography="label"
              labelColor="text-primary"
            >
              Last Name:
            </MicroUnit>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
        </>
      )}

      <div className="form-group">
        <MicroUnit as="label" labelTypography="label" labelColor="text-primary">
          Email:
        </MicroUnit>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <MicroUnit as="label" labelTypography="label" labelColor="text-primary">
          Password:
        </MicroUnit>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <p
          className={`weak-password-prompt ${
            showWeakPasswordPrompt ? 'show' : ''
          }`}
        >
          password must contain a min of 12 letters, numbers and capitals.
        </p>
      </div>

      <Button width={responsiveButtonWidth} type="submit" disabled={loading}>
        {loading
          ? mode === 'login'
            ? 'Logging in...'
            : 'Signing up...'
          : mode === 'login'
            ? 'Login'
            : 'Sign Up'}
      </Button>

      <Unit
        layout="flex"
        flexDirection={responsiveArrangement}
        paddingTop="md"
        paddingBottom="xs"
        width={responsiveButtonWidth}
      >
        <MicroUnit as="p" pTypography="body-small" pColor="light">
          {mode === 'login'
            ? "Don't have an account?"
            : 'Already have an account?'}
        </MicroUnit>
        <Button
          variant="primary"
          onClick={toggleAuthState}
          className="auth-toggle"
          width={responsiveButtonWidth}
        >
          {mode === 'login' ? 'Sign up' : 'Log in'}
        </Button>

        {/* <Unit>
            <Button
              type="button"
              onClick={toggleAuthState}
              className="auth-toggle"
            >
              Reset Password
            </Button>
          </Unit> */}
      </Unit>
      <Unit
        layout="flex"
        flexDirection={responsiveArrangement}
        paddingTop="md"
        width={responsiveSize}
      >
        <MicroUnit
          as="p"
          pTypography="body-small"
          pColor="light"
          className="reset-field-text"
        >
          {mode === 'login' ? 'forgot password?' : ''}
        </MicroUnit>
        {mode === 'login' && (
          <Link to="/reset-password">
            <Button type="button" variant="secondary" width="5">
              Reset Password
            </Button>
          </Link>
        )}
      </Unit>
    </Assembly>
  );
};

export default AuthForm;
